import L from 'leaflet';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';

import LeafletOpacitySlider from './LeafletOpacitySlider';
import useLeafletMap from './useLeafletMap';

// The opacity slider at the end of the zoom control block, or in a block of its own on a map
// without one
function LeafletOpacityControl(props) {
  const {
    value,
    title,
    onChange,
  } = props;
  const map = useLeafletMap();
  const [holder, setHolder] = useState(null);

  useEffect(
    () => {
      if (!map) return undefined;
      const zoomBar = map.zoomControl?.getContainer();
      let control;
      let element;
      if (zoomBar) {
        element = L.DomUtil.create('div', '', zoomBar);
      } else {
        control = L.control({ position: 'topleft' });
        control.onAdd = () => {
          element = L.DomUtil.create('div', 'leaflet-bar');
          return element;
        };
        control.addTo(map);
      }
      // Dragging the thumb must neither pan nor zoom the map
      L.DomEvent.disableClickPropagation(element);
      L.DomEvent.disableScrollPropagation(element);
      setHolder(element);
      return () => {
        setHolder(null);
        if (control) control.remove();
        else element.remove();
      };
    },
    [map],
  );

  if (!holder) return null;
  return createPortal(
    <LeafletOpacitySlider
      value={value}
      title={title}
      onChange={onChange}
    />,
    holder,
  );
}

LeafletOpacityControl.propTypes = {
  // 0 to 1
  value: PropTypes.number.isRequired,
  title: PropTypes.string,
  onChange: PropTypes.func.isRequired,
};

export default LeafletOpacityControl;
